import moment from 'moment';
import dateStringFormats from '../locale/dateStringFormats';
import {i18n} from "../plugins/vue-i18n";

export default {
  data() {
    return {
      currentLocale: null,
      datepickerFormat: {
        // Date to String
        stringify: (date) => {
          return this.$d(date);
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, dateStringFormats[this.currentLocale]).toDate() : null
        }
      },
    }
  },
  created() {
   this.currentLocale = i18n._vm.locale;
  }
};
